<div class="entity-form-wrapper" [class.view-readonly]="isViewMode">

  <form [formGroup]="entityForm">

    <!--Top-level Tab Group-->
    <mat-card class="no_box_shadow tab-card">
      <div class="tab-group-wrapper">
        <!-- Toggles floated to the right of the tab header row -->
        <div class="tab-header-actions">
          <mat-hint class="form-error-hint">{{message}}</mat-hint>
          <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked" [ngModelOptions]="{standalone: true}"
              *ngIf="showDeactivateToggle && entityId">Deactivate Entity</mat-slide-toggle>
          <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked" [ngModelOptions]="{standalone: true}"
              *ngIf="showReactivateToggle && entityId">Reactivate Entity</mat-slide-toggle>
        </div>

      <mat-tab-group #entityTabGroup animationDuration="0ms" class="entity-tab-group" mat-stretch-tabs="false">

        <!-- Tab 1: Entity Details-->
        <mat-tab label="Entity Details">
          <div class="tab-content">

            <!-- Header row: Code | Name | Alias | Legal Name | Company Type, all in one row -->
            <div class="form-grid-4 entity-header-grid">
              <mat-form-field appearance="fill">
                <mat-label>Entity Code</mat-label>
                <input matInput placeholder="Auto-generated" autocomplete="off" formControlName="code"
                       readonly maxlength="6">
                <mat-error *ngIf="code.touched && code.hasError('maxlength') && code.invalid">
                  Entity code should not be greater than 6 characters
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Entity Name</mat-label>
                <input matInput placeholder="Entity Name" autocomplete="off" formControlName="name" required maxlength="60"
                       (blur)="trimControl(name)">
                <mat-error *ngIf="name.touched && name.invalid">{{ getNameErrorMessage() }}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Company Type</mat-label>
                <mat-select formControlName='companyType' required placeholder="Select Company Type">
                  <mat-option>
                    <ngx-mat-select-search [searching]="searching" [formControl]="companySearchCtrl"
                        noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Company Type">
                      <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let company of filteredCompanyType | async" [value]="company.key">
                    {{company.label}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="companyType.touched && companyType.hasError('required') && companyType.invalid">Company type is required</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" floatLabel="always" class="entity-alias-field">
                <mat-label>Entity Alias</mat-label>
                <mat-chip-grid #entityChipList>
                  <mat-chip-row *ngFor="let entity of getEntityAlias(); let i = index;"
                      [removable]="!disableSubmit" (removed)="removeEntityAlias(i)">
                    {{entity.name}}
                    <mat-icon matChipRemove *ngIf="!disableSubmit">cancel</mat-icon>
                  </mat-chip-row>
                  <input placeholder="Add Entity Alias...." autocomplete="off"
                         [matChipInputFor]="entityChipList"
                         [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                         [matChipInputAddOnBlur]="true"
                         [disabled]="disableSubmit"
                         (matChipInputTokenEnd)="addEntityAlias($event)"/>
                </mat-chip-grid>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Entity Legal Name</mat-label>
                <input matInput placeholder="Entity Legal Name" autocomplete="off" formControlName="legalName" maxlength="60"
                       (blur)="trimControl(legalName)">
                <mat-error *ngIf="legalName.hasError('checkEqual') && legalName.invalid">Entity legal name should not be same as entity name</mat-error>
                <mat-error *ngIf="legalName.hasError('maxlength') && legalName.invalid">Entity legal name should not be more than 60 characters</mat-error>
              </mat-form-field>

              
            </div>

            <!-- Key Contact Person Details -->
            <div class="tab-section">
              <h4 class="tab-section-title">Key Contact Person Details</h4>
              <div class="form-grid-3">
                <mat-form-field appearance="fill">
                  <mat-label>Name</mat-label>
                  <input matInput placeholder="Key Person Name" autocomplete="off" formControlName="keyPersonName" maxlength="40"
                         (blur)="trimControl(keyPersonName)">
                  <mat-error *ngIf="keyPersonName.touched && keyPersonName.hasError('maxlength')">Key person name should not be more than 40 characters</mat-error>
                  <mat-error *ngIf="keyPersonName.touched && keyPersonName.hasError('pattern')">Key Contact Person Name should contain alphabets only.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" floatLabel="always" class="email-chip-field">
                  <mat-label>Email-Id</mat-label>
                  <mat-chip-grid #emailChipList>
                    <mat-chip-row *ngFor="let email of getEmails().controls; let i = index"
                        [removable]="!disableSubmit" (removed)="removeEmail(i)"
                        [color]="email.invalid && email.touched ? 'warn' : ''">
                      {{ email.value }}
                      <mat-icon matChipRemove *ngIf="!disableSubmit">cancel</mat-icon>
                    </mat-chip-row>
                    <input placeholder="Add Email..." [matChipInputFor]="emailChipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                        [disabled]="disableSubmit"
                        (matChipInputTokenEnd)="addEmails($event)"/>
                  </mat-chip-grid>
                  <mat-error *ngIf="duplicateEmailError">{{ duplicateEmailError }}</mat-error>
                  <div *ngFor="let email of getEmails().controls; let i = index">
                    <mat-error *ngIf="email.invalid && email.touched">Invalid Email: {{ email.value }}</mat-error>
                    <mat-error *ngIf="email.errors?.maxlength">Email cannot exceed 100 characters</mat-error>
                  </div>
                </mat-form-field>

                <!-- Mobile No. -->
                <div class="mobile-number-cell">
                  <mat-form-field appearance="fill" class="dial-code-field" floatLabel="always">
                    <mat-label>Country Code</mat-label>
                    <input matInput placeholder="country code" [formControl]="dialCodeSearchCtrl" [matAutocomplete]="dialAuto" [disabled]="disableSubmit">
                    <mat-autocomplete #dialAuto="matAutocomplete" (optionSelected)="onCountrySelected($event.option.value)"
                        [displayWith]="displayDialCode">
                      <mat-option *ngFor="let item of filteredDialCodes$ | async" [value]="item.dialCode">
                        {{ item.countryName }} ({{ item.dialCode }})
                      </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix *ngIf="dialCodeSearchCtrl.value && !disableSubmit" (click)="clearSearch()" type="button"
                        aria-label="Clear search">
                      <mat-icon>close</mat-icon>
                    </button>
                    <mat-icon matSuffix>search</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="cell-number-field" floatLabel="always">
                    <mat-label>Mobile No.</mat-label>
                    <mat-chip-grid #chipCell class="scrollable-chip-list aligned-chip-list">
                      <div class="chip-container">
                        <mat-chip-row *ngFor="let phoneGroup of cellNumberDetails.controls; let i = index"
                            [class.invalid-chip]="isChipInvalid(phoneGroup.get('number'))" [removable]="!disableSubmit" (removed)="removePhoneNumber(i)">
                          {{ phoneGroup.get('dialCode').value }} {{ phoneGroup.get('number').value }}
                          <mat-icon matChipRemove *ngIf="!disableSubmit">cancel</mat-icon>
                        </mat-chip-row>
                      </div>
                      <input #phoneInput id="phoneInput" matInput [matChipInputFor]="chipCell"
                          placeholder="Add number..."
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="true"
                          (matChipInputTokenEnd)="addPhoneNumber($event)"
                          (keydown)="onPhoneKeyDown($event)" (blur)="validateCellNumberDetails()"
                          [disabled]="disableSubmit">
                    </mat-chip-grid>
                    <mat-icon aria-hidden="false" [matTooltip]="iconTextCell" matTooltipClass="white-tooltip"
                        aria-label="Information icon" class="cellIcon">info</mat-icon>
                    <mat-error *ngIf="cellNumberDetails.hasError('invalidNumbers')">
                      {{ cellNumberDetails.errors?.invalidNumbers.join(', ') }}
                    </mat-error>
                    <mat-error *ngIf="cellNumberDetails.hasError('maxLength')">
                      Phone number cannot exceed more than 15 digits
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Registered Address Details -->
            <div class="tab-section">
              <h4 class="tab-section-title">Registered Address Details</h4>
              <app-address [addressConfig]="addressConfig" [disableSubmit]="disableSubmit"></app-address>
            </div>

            <!-- Entity Type -->
            <div class="tab-section">
              <h4 class="tab-section-title">Entity Type <span style="color:red">*</span></h4>
              <div class="entity-type-grid">
                <ng-container *ngFor="let entity of entityDetailsList">
                  <mat-checkbox [value]="entity.name"
                      (change)="onEntityDetailChanged(entity.name, $event)"
                      [checked]="entity.isSelected" [disabled]="disableSubmit" *ngIf="!entity.isHidden">
                    {{entity.label}}
                  </mat-checkbox>
                </ng-container>
              </div>
            </div>

          </div>
        </mat-tab>

        <!--Tab 2: Tax & Credit Details-->
        <mat-tab label="Tax & Credit Details">
          <div class="tab-content">

            <!-- Row 1: Domicile Type | Entity GST Type | GST No | PAN No -->
            <div class="form-grid-4">
              <mat-form-field appearance="fill">
                <mat-label>Domicile Type</mat-label>
                <mat-select formControlName='domicile' placeholder="Select Domicile Type" required>
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let domicile of domicileTypes" [value]="domicile.key">
                    {{domicile.label}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="domicile.touched && domicile.hasError('required') && domicile.invalid">Domicile type is required</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" *ngIf="domicile.value==='DOMESTIC'">
                <mat-label>Entity GST Type</mat-label>
                <mat-select formControlName='gstType' placeholder="Select Entity GST Type" required>
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let gst of gstTypes" [value]="gst.key">{{gst.label}}</mat-option>
                </mat-select>
                <mat-error *ngIf="gstType.touched && gstType.hasError('required') && gstType.invalid">GST type is required</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" *ngIf="gstType.value==='REGISTERED'">
                <mat-label>GST No</mat-label>
                <input matInput placeholder="e.g. 22AAAAA0000A1Z5" autocomplete="off" formControlName="gstNo"
                       required maxlength="15"
                       (input)="gstNo.setValue($event.target['value'].toUpperCase(), {emitEvent:false})"
                       (blur)="trimControl(gstNo)">
                <mat-error *ngIf="gstNo.touched && gstNo.hasError('required') && gstNo.invalid">GST No is required</mat-error>
                <mat-error *ngIf="gstNo.touched && gstNo.hasError('pattern') && gstNo.invalid">Enter valid GST number (e.g. 22AAAAA0000A1Z5)</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>PAN No. / Income Tax No</mat-label>
                <input matInput autocomplete="off" formControlName="panNoTaxId" required maxlength="16"
                       [placeholder]="domicile.value==='DOMESTIC' ? 'e.g. AAAAA0000A' : 'Income Tax No'"
                       (input)="panNoTaxId.setValue($event.target['value'].toUpperCase(), {emitEvent:false})"
                       (blur)="trimControl(panNoTaxId)">
                <mat-error *ngIf="panNoTaxId.touched && panNoTaxId.hasError('required') && panNoTaxId.invalid">PAN No / Income Tax No is required</mat-error>
                <mat-error *ngIf="panNoTaxId.touched && panNoTaxId.hasError('pattern') && panNoTaxId.invalid">
                  {{domicile.value==='DOMESTIC' ? 'Enter valid PAN number (e.g. AAAAA0000A)' : 'Only alphanumeric characters allowed'}}
                </mat-error>
                <mat-error *ngIf="panNoTaxId.touched && panNoTaxId.hasError('maxlength') && panNoTaxId.invalid">Should not be more than 16 characters</mat-error>
              </mat-form-field>
            </div>

            <!-- TDS row: Exemption | WEF | Upto | %age | Upload -->
            <div class="tds-row-inline" *ngIf="domicile.value!=='FOREIGN'">
              <mat-form-field appearance="fill" class="tds-field">
                <mat-label>TDS Exemption</mat-label>
                <mat-select formControlName='tdsExemption' required placeholder="TDS Exemption">
                  <mat-option *ngFor="let item of tdsExemptionList" [value]="item.key">{{item.label}}</mat-option>
                </mat-select>
                <mat-error *ngIf="tdsExemption.hasError('required') && tdsExemption.touched && tdsExemption.invalid">TDS exemption is required</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" class="tds-field" *ngIf="tdsExemption.value=='PARTIAL' || tdsExemption.value=='TOTAL'">
                <mat-label>Exemption WEF</mat-label>
                <input matInput [matDatepicker]="picker1" (click)="picker1.open()" formControlName="tdsExemptionWefDate"
                       placeholder="DD/MM/YYYY" autocomplete="off" required
                  [max]="tdsExemptionValidUptoDate.value">
                <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="disableSubmit"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error *ngIf="tdsExemptionWefDate.hasError('required') && tdsExemptionWefDate.touched">WEF date is required</mat-error>
                <mat-error *ngIf="tdsExemptionWefDate.hasError('matDatepickerMax') && tdsExemptionWefDate.touched">WEF must be before Exemption Upto date</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" class="tds-field" *ngIf="tdsExemption.value=='PARTIAL' || tdsExemption.value=='TOTAL'">
                <mat-label>Exemption Upto</mat-label>
                <input matInput [matDatepicker]="picker" (click)="picker.open()" formControlName="tdsExemptionValidUptoDate"
                       placeholder="DD/MM/YYYY" autocomplete="off" required
                  [min]="tdsExemptionWefDate.value">
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="disableSubmit"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="tdsExemptionValidUptoDate.hasError('required') && tdsExemptionValidUptoDate.touched">Upto date is required</mat-error>
                <mat-error *ngIf="tdsExemptionValidUptoDate.hasError('matDatepickerMin') && tdsExemptionValidUptoDate.touched">Upto must be after Exemption WEF date</mat-error>
              </mat-form-field>

              <mat-form-field class="tds-field" appearance="fill" *ngIf="tdsExemption.value=='PARTIAL'">
                <mat-label>TDS Exemption %age</mat-label>
                <input matInput placeholder="0 – 100" autocomplete="off" inputmode="decimal"
                       formControlName="tdsExemptionPercentage" required>
                <mat-error *ngIf="tdsExemptionPercentage.hasError('required') && tdsExemptionPercentage.touched">TDS percentage is required</mat-error>
                <mat-error *ngIf="tdsExemptionPercentage.hasError('pattern') && tdsExemptionPercentage.touched">Enter a value between 0.01 and 99.99 (up to 2 decimal places)</mat-error>
              </mat-form-field>

              <div class="upload-inline" *ngIf="tdsExemption.value !== 'NONE'">
                <span class="upload-label">Upload Exemption Certificate</span>
                <input type="file" hidden #fileInput accept=".pdf,.jpg,.jpeg,.png" (change)="filesSelected($event.target['files'])"/>
                <mat-icon class="__upload_icon cursorPointer green-color" *ngIf="!(tdsDocument || fileName)"
                          (click)="!disableSubmit && fileInput.click()">cloud_upload</mat-icon>
                <div class="uploaded-file-cell" *ngIf="tdsDocument || fileName">
                  <mat-icon class="uploaded-icon">cloud_done</mat-icon>
                  <span class="uploaded-file-name" [matTooltip]="fileName">{{ fileName }}</span>
                  <mat-icon class="preview-icon" matTooltip="Preview" (click)="previewTdsFile()">visibility</mat-icon>
                  <mat-icon class="download-icon" matTooltip="Download" (click)="downloadFile()">file_download</mat-icon>
                  <mat-icon class="reupload-icon" *ngIf="!disableSubmit" matTooltip="Replace" (click)="fileInput.click()">cloud_upload</mat-icon>
                </div>
              </div>
            </div>

            <!-- Charge Mechanism Type -->
            <div class="charge-mechanism-row">
              <span class="charge-mechanism-label">Charge Mechanism Type: <span style="color:red">*</span></span>
              <mat-radio-group formControlName="chargeMechanismType" class="charge-mechanism-group">
                <mat-radio-button value="FCM">FCM</mat-radio-button>
                <mat-radio-button value="RCM">RCM</mat-radio-button>
                <mat-radio-button value="NA">NA</mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Entity Credit Details -->
            <div class="tab-section">
              <h4 class="tab-section-title">Entity Credit Details</h4>
              <app-credit-terms [disableSubmit]="disableSubmit"
                                [currencyName]="currencyName?.value"></app-credit-terms>
            </div>

          </div>
        </mat-tab>

        <!-- Tab 3: Group Details -->
        <mat-tab label="Group Details">
          <div class="tab-content" formGroupName="groups">

            <!-- Row 1: Group Name | Group Code | Upload Entity Company Logo | View Link Entities -->
            <div class="group-row-1">
              <mat-form-field appearance="fill">
                <mat-label>Group Name</mat-label>
                <input #groupNameInput matInput placeholder="Search by name or code"
                       formControlName="name"
                       [matAutocomplete]="groupAuto"
                       #groupTrigger="matAutocompleteTrigger"
                       autocomplete="off" maxlength="60"
                       (blur)="trimControl(groupName)">
                <button mat-icon-button matSuffix type="button"
                        (click)="groupTrigger.openPanel(); groupNameInput.focus()" [disabled]="disableSubmit">
                  <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-autocomplete #groupAuto="matAutocomplete" (opened)="refreshEntityGroupList()">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let group of filteredGroup | async" [value]="group.name">
                    <div class="group-option">
                      <span class="group-option-code">{{group.code}}</span>
                      <span class="group-option-name">{{group.name}}</span>
                    </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Group Code</mat-label>
                <input matInput placeholder="Group Code" formControlName="code"
                       autocomplete="off" maxlength="10"
                       [readonly]="isExistingGroup"
                       (blur)="trimControl(groupCode)">
                <mat-hint *ngIf="!isExistingGroup && !groupCode.value">Auto-generated if left blank</mat-hint>
              </mat-form-field>

              <div class="logo-upload-cell">
                <span class="logo-upload-label">Upload Entity Company Logo</span>
                <input type="file" hidden #logoInput accept=".png,.jpg,.jpeg,.svg"
                       (change)="onLogoSelected($event)" [disabled]="disableSubmit">
                <button mat-icon-button (click)="logoInput.click()" type="button" class="logo-upload-btn"
                        [disabled]="disableSubmit" *ngIf="!(logoDocument || logoFileName)">
                  <mat-icon>cloud_upload</mat-icon>
                </button>
                <div class="uploaded-file-cell" *ngIf="logoDocument || logoFileName">
                  <mat-icon class="uploaded-icon">cloud_done</mat-icon>
                  <span class="uploaded-file-name" [matTooltip]="logoFileName">{{ logoFileName }}</span>
                  <mat-icon class="preview-icon" matTooltip="Preview" (click)="previewLogoFile()">visibility</mat-icon>
                  <mat-icon class="download-icon" matTooltip="Download" (click)="downloadLogo()">file_download</mat-icon>
                  <mat-icon class="reupload-icon" *ngIf="!disableSubmit" matTooltip="Replace" (click)="logoInput.click()">cloud_upload</mat-icon>
                </div>
              </div>

              <div class="view-link-entities">
                <button mat-stroked-button color="primary" class="view-link-btn"
                        (click)="onViewCompanies()" [disabled]="disableSubmit || (!groupCode.value && !groupName.value)">
                  View Link Entities
                </button>
              </div>
            </div>

            <!-- Row 2: Display Name -->
            <div class="group-row-2">
              <mat-form-field appearance="fill" class="display-name-field">
                <mat-label>Display Name for Mobile App &amp; Email Alerts for Customer of my Customers</mat-label>
                <input matInput [formControl]="$any(groupDisplayName)" autocomplete="off" maxlength="100"
                       (blur)="trimControl(groupDisplayName)">
                <mat-hint align="end">{{groupDisplayName?.value?.length || 0}}/100</mat-hint>
              </mat-form-field>
            </div>

          </div>
        </mat-tab>

        <!-- Tab 4: KYC Details -->
        <mat-tab label="KYC Details">
          <div class="tab-content">
            <div class="container">
                <app-kyc-details [countryId]="countryIdToKYC" [buttonHidden]="true" [referenceName]="'Entity_KYC'"
                  [dataById]="idToKYC" [disableTable]="disableSubmit">
              </app-kyc-details>
            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
      </div><!-- end tab-group-wrapper -->
    </mat-card>

    <!--Entity Audit Log (edit/view mode only). Sits outside the entity's own tab-group so
         it shows regardless of which entity tab (Entity Details/Group Details/Tax & Credit
         Details/KYC Details) is currently active — mirroring how each branch's own "View
         Log" shows across all of that branch's sub-tabs. Branch logs live inline within
         each embedded app-entity-branch-form instead, each with its own checkbox. Wrapped
         in its own card (matching the tab-card above) so it doesn't look like a bare block
         floating outside the card layout. -->
    <mat-card class="no_box_shadow tab-card audit-log-card" *ngIf="id.value">
      <mat-card-content>
        <app-audit-log-tabs [referenceId]="id.value" [referenceType]="'EXTERNAL_ENTITY'"
            [tabs]="auditLogTabs"></app-audit-log-tabs>
      </mat-card-content>
    </mat-card>

    <!--Branch Details-->
    <mat-card class="no_box_shadow branch-section">
      <mat-card-content>

        <div class="branch-tabs-wrapper">
          <mat-tab-group [(selectedIndex)]="activeBranchIndex" animationDuration="0ms" mat-stretch-tabs="false"
            (selectedIndexChange)="onBranchTabSelected($event)" class="branch-tab-group">
            <!-- Branch 1: always eager -->
            <mat-tab *ngIf="branchList.length > 0">
              <ng-template mat-tab-label>Branch 1</ng-template>
              <app-entity-branch-form
                [embedded]="true"
                [embeddedEntityId]="entityId"
                [embeddedBranchId]="branchList[0].id"
                [disableSubmit]="disableSubmit"
                [prefillAddress]="!entityId ? entityBranch1Address : null"
                [prefillBranchData]="branchList[0].id ? branchDetailsMap.get(branchList[0].id) : null"
                [entityCreditDefaults]="!branchList[0].id ? entityCreditDefaults : null"
                [customerFlag]="creditComponent?.creditTermForm?.get('customerFlag')?.value"
                [vendorFlag]="creditComponent?.creditTermForm?.get('vendorFlag')?.value"
                [customerCreditCurrencyId]="creditComponent?.creditTermForm?.get('customerCurrencyId')?.value"
                [customerCreditCurrencyName]="creditComponent?.creditTermForm?.get('customerCurrencyName')?.value"
                [vendorCreditCurrencyId]="creditComponent?.creditTermForm?.get('vendorCurrencyId')?.value"
                [vendorCreditCurrencyName]="creditComponent?.creditTermForm?.get('vendorCurrencyName')?.value"
                (branchSaved)="onBranchSaved($event, 0)"
                (headquarterSelected)="onHeadquarterSelected(0)"
                (branchCreditAmountChanged)="validateBranchCreditAmounts()">
              </app-entity-branch-form>
            </mat-tab>

            <!-- Branch 2+: EDIT mode — lazy first load, then kept in DOM so unsaved changes survive tab switches -->
            <mat-tab *ngFor="let branch of (entityId ? (branchList | slice:1) : []); let i = index; trackBy: trackBranch">
              <ng-template mat-tab-label>
                Branch {{i + 2}}
                <mat-icon *ngIf="!disableSubmit && !branch.id" class="branch-tab-close-icon"
                          (click)="$event.stopPropagation(); removeBranch(i + 1)"
                          matTooltip="Remove branch">close</mat-icon>
              </ng-template>
              <app-entity-branch-form *ngIf="visitedBranchIndexes.has(i + 1)"
                [embedded]="true"
                [embeddedEntityId]="entityId"
                [embeddedBranchId]="branch.id"
                [disableSubmit]="disableSubmit"
                [prefillAddress]="null"
                [prefillBranchData]="branch.id ? branchDetailsMap.get(branch.id) : null"
                [entityCreditDefaults]="!branch.id ? entityCreditDefaults : null"
                [customerFlag]="creditComponent?.creditTermForm?.get('customerFlag')?.value"
                [vendorFlag]="creditComponent?.creditTermForm?.get('vendorFlag')?.value"
                [customerCreditCurrencyId]="creditComponent?.creditTermForm?.get('customerCurrencyId')?.value"
                [customerCreditCurrencyName]="creditComponent?.creditTermForm?.get('customerCurrencyName')?.value"
                [vendorCreditCurrencyId]="creditComponent?.creditTermForm?.get('vendorCurrencyId')?.value"
                [vendorCreditCurrencyName]="creditComponent?.creditTermForm?.get('vendorCurrencyName')?.value"
                (branchSaved)="onBranchSaved($event, i + 1)"
                (headquarterSelected)="onHeadquarterSelected(i + 1)"
                (branchCreditAmountChanged)="validateBranchCreditAmounts()">
              </app-entity-branch-form>
            </mat-tab>

            <!-- Branch 2+: ADD mode — eager (no matTabContent) -->
            <mat-tab *ngFor="let branch of (!entityId ? (branchList | slice:1) : []); let i = index; trackBy: trackBranch">
              <ng-template mat-tab-label>
                Branch {{i + 2}}
                <mat-icon *ngIf="!disableSubmit" class="branch-tab-close-icon"
                          (click)="$event.stopPropagation(); removeBranch(i + 1)"
                          matTooltip="Remove branch">close</mat-icon>
              </ng-template>
              <app-entity-branch-form
                [embedded]="true"
                [embeddedEntityId]="entityId"
                [embeddedBranchId]="branch.id"
                [disableSubmit]="disableSubmit"
                [prefillAddress]="null"
                [prefillBranchData]="null"
                [entityCreditDefaults]="entityCreditDefaults"
                [customerFlag]="creditComponent?.creditTermForm?.get('customerFlag')?.value"
                [vendorFlag]="creditComponent?.creditTermForm?.get('vendorFlag')?.value"
                [customerCreditCurrencyId]="creditComponent?.creditTermForm?.get('customerCurrencyId')?.value"
                [customerCreditCurrencyName]="creditComponent?.creditTermForm?.get('customerCurrencyName')?.value"
                [vendorCreditCurrencyId]="creditComponent?.creditTermForm?.get('vendorCurrencyId')?.value"
                [vendorCreditCurrencyName]="creditComponent?.creditTermForm?.get('vendorCurrencyName')?.value"
                (branchSaved)="onBranchSaved($event, i + 1)"
                (headquarterSelected)="onHeadquarterSelected(i + 1)"
                (branchCreditAmountChanged)="validateBranchCreditAmounts()">
              </app-entity-branch-form>
            </mat-tab>
          </mat-tab-group>

          <button type="button" class="__add_client branch-add-btn"
              (click)="addBranch()" [disabled]="disableSubmit">
            <mat-icon class="__icon">add_circle</mat-icon>
            Add Branch
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!--Action buttons-->
    <mat-card-actions class="form-actions">
      <button type="button" mat-button color="secondary" (click)="saveAsDraft()" [disabled]="disableSubmit">SAVE AS DRAFT</button>
      <button type="button" mat-button color="primary" *ngIf="getSaveDisableCondn()" (click)="onSave()">SAVE</button>
      <button type="button" mat-button color="cancel" (click)="cancel()">CANCEL</button>
    </mat-card-actions>

  </form>
</div>
